import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'space-lite',
    // TODO: update these details
    description: 'Space Lite App Description.',
    icon: 'space',
    name: 'Space Lite',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: true,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
